var map = {
	"./dice.webp": 1676,
	"./esports-bg.webp": 1677,
	"./esports-ctg.webp": 1678,
	"./im-img.webp": 1679,
	"./im-title-cn.webp": 1680,
	"./im-title-en.webp": 1681,
	"./snooker.webp": 1682,
	"./spade.webp": 1683,
	"./tfg-img.webp": 1684,
	"./tfg-title-cn.webp": 1685,
	"./tfg-title-en.webp": 1686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1675;